import Div from "@jumbo/shared/Div/Div";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import {useEffect, useState} from "react";
import {get} from "../../../common/network";
import ImportedMatterCard from "./ImportedMatterCard";
import ImportedMatterNotification from "./ImportedMatterNotification";
import UploadMatters from "./UploadMatters";
import "./ImportMatter.css";
import { formatDate } from "app/pages/Docgen/constants/date_format";


const ImportMatter = () => {
    const [uploadStatus, setUploadStatus] = useState("");
    const [importDetails, setImportDetails] = useState(null);
    const [mattersData, setMattersData] = useState([]);
    const [isFileData, setFileData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    /**
     * Upload handler function for uploading matters
     * @param files
     * @returns {Promise<void>}
     */
    const uploadHandler = async (files) => {
        // Below is a rough code for demo
        if (files) {
            let file = files[0];
            let fileName = file.name;
            let fileSize = (file.size / 1024).toFixed(2);
            const formData = new FormData();
            formData.append("file", file, file.name);
            setFileData(formData);
            setImportDetails({
                label: `${fileName} - ${fileSize}kb`
            });
            setUploadStatus("success-message");
        }
    };

    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
            try {
                const response = await get(`docgen/import/matters?page=1&pageSize=100&sort=updated_at:desc`);
                setMattersData(response?.data || []);
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [importDetails]);

    function calculateDurationInSeconds(startedAt, finishedAt) {
        const startedTimestamp = Date.parse(startedAt); // Convert to Unix timestamp in milliseconds
        const finishedTimestamp = Date.parse(finishedAt); // Convert to Unix timestamp in milliseconds

        if (!isNaN(startedTimestamp) && !isNaN(finishedTimestamp)) {
            const durationInSeconds = (finishedTimestamp - startedTimestamp) / 1000;

            const hours = Math.floor(durationInSeconds / 3600);
            const minutes = Math.floor((durationInSeconds % 3600) / 60);
            const seconds = Math.floor(durationInSeconds % 60);

            // return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            const formattedDuration = `${hours > 0 ? hours + " hrs " : ""}${
                minutes > 0 ? minutes + " min " : ""
            }${seconds > 0 ? seconds + " sec" : "1 sec"}`;
            return formattedDuration.trim(); // Remove trailing spaces
        } else {
            return "0 hours 0 min 0 sec"; // Return 0 duration if invalid timestamps
        }
    }

    return (
        <div className="page-content-wrapper">
            <Box className="w-100">
                <div>
                    {" "}
                    {isUploading ? (
                        <Div
                            sx={{
                                width: "100%",
                                height: "100%",
                                minHeight: "60vh",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",

                                ".btn-loader-icon": {
                                    width: "60px",
                                    height: "60px",
                                    border: "5px solid gray",
                                    borderColor: "transparent gray gray gray",
                                    borderRadius: "50%",
                                    animation: "rotate .5s linear infinite"
                                }
                            }}
                        >
                            <div className="btn-loader-icon"></div>
                        </Div>
                    ) : (
                        <>
                            {isLoading ? (
                                <Skeleton
                                    animation="wave"
                                    sx={{
                                        minHeight: "330px",
                                        width: "100%",
                                        margin: "-70px 0px",
                                        padding: "0px"
                                    }}
                                />
                            ) : (
                                <>
                                    <UploadMatters onUpload={uploadHandler}/>
                                    {importDetails && (<ImportedMatterNotification label={importDetails.label} uploadStatus={uploadStatus} setImportDetails={setImportDetails} setUploadStatus={setUploadStatus} isFileData={isFileData} setFileData={setFileData} setMattersData={setMattersData} mattersData={mattersData} isUploading={isUploading} setIsUploading={setIsUploading}/>)}
                                </>
                            )}
                        </>
                    )}
                    {isLoading ? (
                        <Div
                            sx={{
                                width: "100%",
                                height: "100%",
                                minHeight: "60vh",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",

                                ".btn-loader-icon": {
                                    width: "60px",
                                    height: "60px",
                                    border: "5px solid gray",
                                    borderColor: "transparent gray gray gray",
                                    borderRadius: "50%",
                                    animation: "rotate .5s linear infinite"
                                }
                            }}
                        >
                            <div className="btn-loader-icon"></div>
                        </Div>
                    ) : (
                        <Paper sx={{p: "20px", backgroundColor: "#F6F6F6"}}>
                            {mattersData?.map(item => (<ImportedMatterCard key={item.id} id={item.id} name="input_import_matter.csv" date={formatDate(item.started_at)} duration={calculateDurationInSeconds(item.started_at, item.finished_at || item.updated_at)} total={item.total_input} imported={item.import_count} addedBy={item.created_by_details.first_name + " " + item.created_by_details.last_name} fullName="output_import_matter.csv" status={item.status} errorMessage={item?.error_message}/>))}
                        </Paper>
                    )}
                </div>
            </Box>
        </div>
    );
};

export default ImportMatter;